var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prism-editor',{staticClass:"prism-code",class:'language-' + _vm.language,attrs:{"value":_vm.value,"highlight":_vm.highlighter},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":_vm.format}})}
var staticRenderFns = []

export { render, staticRenderFns }